import { ENodeVehicle } from '@vae/server/src/interfaces/eNode/eNodeVehicle.interface'
import React from 'react'
import { useTranslation } from 'react-i18next'
import Button from '../../../../components/actions/Button'
import useUser from '../../../../contexts/hooks/useUser'
import { trpc } from '../../../../modules/trpc'

interface ChargingControlsProps {
	vehicle: ENodeVehicle | null | undefined
}

const ChargingControls: React.FC<ChargingControlsProps> = ({ vehicle }) => {
	const utils = trpc.useContext()

	const { user } = useUser()

	const { t } = useTranslation('pages_electricCar', { keyPrefix: 'electricCarDetail' })

	const startChargingMutation = trpc.eNode.charging.control.useMutation({
		onSuccess: () => {
			utils.eNode.vehicles.getSingle.invalidate({
				hashedPid: user?.hashedPid ?? '',
				vehicleId: vehicle?.id ?? '',
			})
			utils.eNode.charging.getSmartChargingStatus.invalidate({
				hashedPid: user?.hashedPid ?? '',
				vehicleId: vehicle?.id ?? '',
			})
		},
		onError: error => {
			console.error('Error controlling charging:', error)
		},
	})

	return (
		<div>
			{vehicle?.chargeState.isCharging ? (
				<Button
					onClick={() => {
						startChargingMutation.mutate({
							hashedPid: user?.hashedPid ?? '',
							vehicleId: vehicle?.id ?? '',
							action: 'STOP',
						})
					}}
					className='m-0'
				>
					{t('stopCharging')}
				</Button>
			) : (
				<Button
					onClick={() => {
						startChargingMutation.mutate({
							hashedPid: user?.hashedPid ?? '',
							vehicleId: vehicle?.id ?? '',
							action: 'START',
						})
					}}
					className='m-0'
				>
					{t('startCharging')}
				</Button>
			)}
		</div>
	)
}

export default ChargingControls
